import apiClient from './api/client';
import { ENDPOINTS } from './api/endpoints';

export const sellerAccountService = {
  getAll: () => apiClient.get(ENDPOINTS.SELLER_ACCOUNTS.GET_ALL),
  connect: (data) => apiClient.post(ENDPOINTS.SELLER_ACCOUNTS.CONNECT, data),
  disconnect: (id) => apiClient.put(ENDPOINTS.SELLER_ACCOUNTS.DISCONNECT(id)),
  reconnect: (id, data) => apiClient.put(ENDPOINTS.SELLER_ACCOUNTS.RECONNECT(id), data),
  delete: (id) => apiClient.delete(ENDPOINTS.SELLER_ACCOUNTS.DELETE(id)),
  checkHealth: (id) => apiClient.get(ENDPOINTS.SELLER_ACCOUNTS.HEALTH_CHECK(id)),
  getMarketplaces: (id) => apiClient.get(ENDPOINTS.SELLER_ACCOUNTS.MARKETPLACES(id)),
};
